import { useMemo } from "react";
import { euro } from "./useFormattedCustomerPrice";

type PriceData = {
    cross_price?: number | null;
    is_early_bird_price_active?: boolean;
};

export function useFormattedCrossPrice(priceData: PriceData): string | null {
    return useMemo(() => {
        const { cross_price: xp, is_early_bird_price_active: early } = priceData;

        // `is_early_bird_price_active` is only present (and must be true) for event items,
        // which still use the legacy early-bird mechanism. For regular items it is undefined,
        // and `cross_price` already comes from AdvancedPriceProvider's cross-price computation.
        const isGatedByEarlyBird = early !== undefined;

        return xp != null && xp > 0 && (!isGatedByEarlyBird || early) ? euro.format(xp) : null;
    }, [priceData.cross_price, priceData.is_early_bird_price_active]);
}